import { Edit } from '@mui/icons-material'
import { SelectScanModal } from '../SelectScanModal/SelectScanModal'
import { useEditDispositionModalLogic } from '../EditDispositionModal/EditDispositionModal.logic'
import LoadingButton from 'components/molecules/LoadingButton/LoadingButton'
import { EditDispositionModal } from '../EditDispositionModal/EditDispositionModal'
import { EditAssetButtonProps } from 'lib/context/EditDocumentedListContext/EditDocumentedList.types'

export const EditAssetButton = ({
  assetgroupId,
  scansArray,
  isProcedureSubmitted,
  assetTray,
  surgeryId,
  bidAssetId,
  scanIds,
  isManualAddition,
  consumableAssetGroup,
  isMultipack,
  isMultipackHardware,
  singleConsumablesCount,
  isSponge,
  assetGroup,
  isUnused = false,
}: EditAssetButtonProps) => {
  const {
    handleEditOnOpen,
    isSelectModalOpen,
    scans,
    isEditModalOpen,
    selectedAssetGroupId,
    scanIsMatching,
  } = useEditDispositionModalLogic({ assetTray, assetGroup, isUnused })

  return (
    <>
      <LoadingButton
        data-testid={`${bidAssetId}-edit-scan-button`}
        variant="outlined"
        value={scanIds}
        onClick={(e) => {
          handleEditOnOpen(
            assetgroupId,
            scansArray,
            e.currentTarget.value,
            consumableAssetGroup,
            isUnused,
            assetGroup
          )
        }}
        disabled={isProcedureSubmitted}
        loading={false}
        size="small"
        sx={{ padding: 0 }}
      >
        <Edit sx={{ transform: 'scale(0.75)' }} />
      </LoadingButton>

      {isSelectModalOpen &&
        scans.length > 1 &&
        assetgroupId === selectedAssetGroupId && (
          <>
            <SelectScanModal
              assetGroup={assetGroup}
              dataTestId={`${bidAssetId}-select-scan`}
              assetTray={assetTray}
              scans={scans}
              surgeryId={surgeryId}
            />
            {scanIsMatching() && (
              <EditDispositionModal
                isUnused={isUnused}
                assetGroup={assetGroup}
                isSponge={isSponge}
                scans={scans}
                isManualAddition={isManualAddition}
                assetTray={assetTray}
                dataTestId={`${bidAssetId}-edit-disposition`}
                isMultipackHardware={isMultipackHardware}
              />
            )}
          </>
        )}

      {isEditModalOpen &&
        assetgroupId === selectedAssetGroupId &&
        scans?.[0]?._id === scanIds?.[0] && (
          <EditDispositionModal
            isUnused={isUnused}
            assetGroup={assetGroup}
            isSponge={isSponge}
            singleConsumablesCount={singleConsumablesCount}
            scans={scans}
            isManualAddition={isManualAddition}
            assetTray={assetTray}
            dataTestId={`${bidAssetId}-edit-disposition`}
            isMultipack={isMultipack}
            isMultipackHardware={isMultipackHardware}
          />
        )}
    </>
  )
}
